import { PHONE_REGEX } from "../utils/Validations";

export const EMAIL_ALREADY_IN_USE = "EMAIL_ALREADY_IN_USE";
export const EMAIL_FIELD_NAME = "email";
export const NAME_FIELD_NAME = "name";
export const PHONE_FIELD_NAME = "phone";
export const COUNTRY_CODE_FIELD_NAME = "countryCode";
export const INSTAGRAM_FIELD_NAME = "instagram";

// Regex patterns from validationRules
const NAME_PATTERN = /^[a-zA-ZÀ-ÿ\s]+$/;
const EMAIL_PATTERN = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const INSTAGRAM_PATTERN = /^@?(?!.*\.\.)(?!.*\.$)[a-zA-Z0-9._]{1,30}$/;

export const isErrorMailAlreadyInUse = (error) => {
  return error.msg === EMAIL_ALREADY_IN_USE;
};

export const errorInPhone = (errors) => {
  return errors.find((error) => error.path === PHONE_FIELD_NAME);
};

export const errorInEmail = (errors) => {
  return errors.find((error) => error.path === EMAIL_FIELD_NAME);
};

export const validationRules = {
  [NAME_FIELD_NAME]: {
    required: "El nombre es requerido",
    pattern: {
      value: NAME_PATTERN,
      message: "El nombre debe contener solo letras y espacios",
    },
    minLength: {
      value: 3,
      message: "El nombre debe tener al menos 3 caracteres",
    },
    maxLength: {
      value: 100,
      message: "El nombre debe tener máximo 100 caracteres",
    },
  },
  [PHONE_FIELD_NAME]: {
    required: "El teléfono es requerido",
    pattern: {
      value: PHONE_REGEX,
      message:
        "El formato debe ser +[código de país][número]. Ej: +541155667788",
    },
    minLength: {
      value: 9,
      message: "El teléfono debe tener mínimo 9 caracteres",
    },
    maxLength: {
      value: 18,
      message: "El teléfono debe tener máximo 18 caracteres",
    },
  },
  [EMAIL_FIELD_NAME]: {
    required: "El correo electrónico es requerido",
    pattern: {
      value: EMAIL_PATTERN,
      message: "Correo electrónico inválido",
    },
  },
  [INSTAGRAM_FIELD_NAME]: {
    pattern: {
      value: INSTAGRAM_PATTERN,
      message:
        "El formato debe ser @usuario o usuario (máximo 100 caracteres, solo letras, números, puntos y guiones bajos)",
    },
    maxLength: {
      value: 30,
      message: "El Instagram debe tener máximo 30 caracteres",
    },
  },
};
